import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const PieChart = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M21.4043 13.25H12.6803L18.4903 19.4231C18.7124 19.659 19.0778 19.6782 19.3062 19.4496C20.729 18.0254 21.7076 16.1055 21.9948 13.9472C22.044 13.5777 21.7554 13.25 21.4043 13.25ZM20.8223 10.7187C20.5194 6.05224 17.0098 2.32329 12.6178 2.00141C12.2825 1.9768 12.0002 2.2772 12.0002 2.63423V11.375H20.2271C20.5632 11.375 20.8455 11.0749 20.8223 10.7187ZM10.2355 13.25V3.98073C10.2355 3.60768 9.92701 3.30104 9.57958 3.35338C5.19828 4.0112 1.84934 8.07804 2.00523 12.9519C2.16552 17.9574 6.22182 22.0622 10.9351 21.9993C12.7881 21.9747 14.5002 21.3403 15.908 20.2793C16.1984 20.0606 16.2175 19.6063 15.9657 19.3387L10.2355 13.25Z" />
  </SvgIcon>
));

PieChart.displayName = 'PieChart';

export default PieChart;
